import React from 'react';
import { Modal } from 'antd';
import { MODAL_VERTICAL_OFFSET } from './modalConstants';

export { MODAL_VERTICAL_OFFSET };

interface ModalPanelProps {
  open: boolean;
  onClose: () => void;
  children?: React.ReactNode;
  width?: string | number;
}

const ModalPanel: React.FC<ModalPanelProps> = ({ open, onClose, children, width = 'fit-content' }) => {
  return (
    <Modal
      open={open}
      footer={null}
      closable={false}
      destroyOnHidden
      width={width}
      style={{ top: 5, margin: '0 auto', padding: 0, transition: 'width 0.2s ease' }}
      styles={{
        body: {
          padding: 0,
          height: `calc(100vh - ${MODAL_VERTICAL_OFFSET}px)`,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          overflow: 'hidden',
          background: '#000',
        },
      }}
      onCancel={onClose}>
      {children}
    </Modal>
  );
};

export default ModalPanel;
